import { Component, Input, EventEmitter, Output, SimpleChanges, SimpleChange} from '@angular/core';

@Component({
  selector: 'app-popup-box',

  template: 
  `<div id="lightboxMessage" class="light-box" *ngIf="message">

  <div class="modal-box no-padding">
    <div class="modal-header header-danger-gov" [ngClass]="{'warning': isWarning}">
        
            <h5 class="text-align-center">
                {{title}}
            </h5>
        
            <i class="fa fa-times-circle faa-red cursor-pointer i-close" aria-hidden="true" (click)="closePopUpFunc()"></i>
        
    </div>

    <div class="modal-body" [ngClass]="{'red': _isError}" [innerHTML]="message">
        
    </div>
  </div>`,

styles: [
` @media print {
    .light-box {
      position: relative;
      margin-top: 10px;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.15);
      page-break-before: always;
      visibility: visible !important;
      overflow: visible !important;
    }
  
    .form-group {
      page-break-inside: avoid;
    }
  }
  
  @media screen {
    .light-box {
        position: fixed;
        top: 20px;
        left: 10%;
        width: 80%;
        height: 98%;
        max-height: 1620px;
        background-color: rgba(0,0,0,0.15);
    }
  }

  @media screen and (max-width: 992px) {
    .light-box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 1620px;
        background-color: rgba(0,0,0,0.15);
    }
  }

  .light-box {
    z-index: 10023;
  }

  .modal-header.warning {
    background: teal;
  }
  
  span.bold {
    font-size: 20px;
    font-weight: 700;
  }
  
  .i-close {
    position: absolute;
      top: 0;
      right: 0;
  }

  .modal-box {
      display: block;
      position: absolute;
      top: 15%;
      left: 22%;
      width: 56%;
      height: auto;
      max-height: 900px;
      background: #fff;
      border-radius: 8px;
      padding: 15px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      z-index: 1000001;
  }
  
  .modal-body {
    word-wrap: break-word;
    text-align: center;
  }

  .modal-body.red {
    color: red;
    font-weight: 600;
  }

  .no-padding {
      padding-left: 0;
      padding-right: 0;
  }
  
  .header-danger-gov {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: #337ab7; 
    color: #fff;
    margin-top: -15px;
    padding-left: 10px;
    padding-right: 10px;
    width:100%;
  }

  .text-align-center {
    width: 100%;
    text-align: center;
  }
  
}`]
})

export class PopupBoxComponent {
    
    @Input() message: string;
    @Input() title: string;
    @Output() closed = new EventEmitter();
    @Input() isWarning: boolean = false;
    @Input() isError: boolean = false;
    _isError = false;

    ngOnChanges(changes: SimpleChanges) {
      const err: SimpleChange = changes.isError;
      if (err) {
        this._isError = this.isError;
      }
    }
    
    closePopUpFunc() {
        this.message = "";
        this.closed.emit();
    }
}